/**
 * Traduce errores técnicos de almacenamiento (R2/S3) a mensaje usable en UI.
 */
export function humanizarErrorSubida(raw) {
  const msg = String(raw || "").trim();
  if (!msg) return "Error de subida";
  if (/SignatureDoesNotMatch|signature we calculated|secret access key and signing/i.test(msg)) {
    return "No se pudo guardar el archivo en el servidor (error de almacenamiento). Pulsa reintentar; si sigue fallando, avisa a sistemas.";
  }
  if (/NotImplemented|x-amz-checksum/i.test(msg)) {
    return "El servidor no aceptó el archivo. Pulsa reintentar la subida.";
  }
  if (/timeout|ETIMEDOUT|ECONNRESET|Network Error|network/i.test(msg)) {
    return "Error de red al subir. Pulsa reintentar; no hace falta volver a elegir el archivo.";
  }
  if (/413|too large|entity too large/i.test(msg)) {
    return "El archivo es demasiado grande. Prueba con uno más ligero o en PDF comprimido.";
  }
  return msg;
}
